// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-mate-src-templates-home-tsx": () => import("./../../../node_modules/gatsby-theme-mate/src/templates/Home.tsx" /* webpackChunkName: "component---node-modules-gatsby-theme-mate-src-templates-home-tsx" */),
  "component---node-modules-gatsby-theme-mate-src-templates-not-found-tsx": () => import("./../../../node_modules/gatsby-theme-mate/src/templates/NotFound.tsx" /* webpackChunkName: "component---node-modules-gatsby-theme-mate-src-templates-not-found-tsx" */)
}

